import styles from './styles.module.scss';

import { Button } from '@cropler/ui-kit';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

export const Notification = ({ message, close }) => {
  return (
    <div className={styles.notification}>
      <CroplerIcon name="warning" width={24} height={24}/>
      <span className={styles.notificationText}>{message}</span>
      <Button type="default" icon={<CroplerIcon name="close"/>} size="small" onClick={close}/>
    </div>
  );
}